import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MaterialCheckModel, DeliveryCutoffTimes, ConfigService } from '@evorait/pace-core';
import { faChevronDown, faChevronUp, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-material-pricing-details-expandable',
    templateUrl: './material-pricing-details-expandable.component.html',
    styleUrls: ['./material-pricing-details-expandable.component.scss'],
})
export class MaterialPricingDetailsExpandableComponent implements OnInit {
    @Input() public material: MaterialCheckModel;
    @Input() public index: number;
    @Input() public displayCustomerPrice: boolean;
    @Input() public displayRepairPrice: boolean;
    @Input() public displayMaterialNotAvailable: boolean;
    @Input() public displayTs: boolean;
    @Input() public displayNdf: boolean;

    @Output()
    public materialDeletedEvent = new EventEmitter<number>();

    public faChevronDown = faChevronDown;
    public faChevronUp = faChevronUp;
    public faTrashAlt = faTrashAlt;
    public isCollapsed = true;
    public isDeliveryCutoffTimeEnabled: boolean;
    public deliveryCutoffTimes: DeliveryCutoffTimes[] = [];

    public constructor(private configService: ConfigService) {}

    public ngOnInit(): void {
        this.isDeliveryCutoffTimeEnabled = this.configService.getEnableDeliveryCutoffTime();
        this.deliveryCutoffTimes = this.material.getDeliveryCutoffTimes();
    }

    public deleteMaterial(): void {
        this.materialDeletedEvent.emit(this.index);
    }
}
